import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { footerQuery } from './queries';

export const useFooter = () => {
  const { locale } = useLocale();
  const { data } = useQuery({
    ...footerQuery({ locale }),
    staleTime: StaleTime.FOREVER,
  });

  return {
    storeLinks: data?.storeLinks,
    footerLinks: data?.footerLinks,
    socialLinks: data?.socialLinks,
  };
};
